export default "__VITE_ASSET__4bfbec09__"